// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"706":"29c8c609","4455":"749c9a0c","9721":"79ff2c8e"}[chunkId] || chunkId) + "." + {"706":"e150ab84550fb091","3248":"d325655c71e463d0","4455":"a339af17d83b4eb0","4786":"d76c8529de5fc833","6173":"1606aad6798f73a8","9463":"7c2221ba899984e4","9721":"312c8efe5223cef9"}[chunkId] + ".js";
};